// root state object.
// each Vuex instance is just a single state tree.
const state = {
  type: null,
  detailData: null,
  count: 0
}

// getters are functions
const getters = {
  evenOrOdd: state => state.count % 2 === 0 ? 'even' : 'odd'
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  increment (state) {
    state.count++
  },
  decrement (state) {
    state.count--
  },
  updateType (state, type) {
    // console.log("updateType > input type:%s, state type:%s", type, state.type)
    state.type = type
    // console.log("updateType > update type:%s", state.type)
  },
  updateData (state, data) {
    // console.debug("updateData > input data:%o, state detailData:%o", data, state.detailData)
    state.detailData = data
    // console.debug("updateData > update detailData:%o", state.detailData)
  },
  clearData (state){
    state.detailData = {}
    // console.debug("clearData > clear detailData:" + state.detailData)
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  increment: ({ commit }) => commit('increment'),
  decrement: ({ commit }) => commit('decrement'),
  incrementIfOdd ({ commit, state }) {
    if ((state.count + 1) % 2 === 0) {
      commit('increment')
    }
  },
  incrementAsync ({ commit }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('increment')
        resolve()
      }, 1000)
    })
  }
}



// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/jw.js